<template>
  <div class="game-table-flush">
  <vue-good-table 
    styleClass="vgt-table condensed vgt-flush"
    v-bind="tableOptions"
    :columns="columns"
    :rows="rows"
    :pagination-options="paginationFor(rows)"
    compactMode>
    <template #table-row="props">
      <div v-if="props.column.field == 'Image'" class="d-block">
        <img 
          :src="imgRoot + props.row.Image" 
          class="avatar avatar-xl img-fluid reward-img reward-zoom"
          :alt="props.row.Reward"
          role="button"
          @click.stop="openRewardPhoto(props.row)"
        >
      </div>
      <div v-else-if="props.column.field == 'Actions'">
        <div class="d-flex flex-row gap-2 justify-content-end">
          <button
            class="btn btn-primary btn-sm px-3 my-1"
            type="button"
            @click="emit('choose-reward-data', props.row.GameID);"
          >
            Vybrat výhru
          </button>          
        </div>
      </div> 
      <span v-else>
        {{ props.formattedRow[props.column.field] }}
      </span>
    </template>
    <template #emptystate>
      <div class="text-center">
        <span>Žádné výhry</span>
      </div>
    </template>
  </vue-good-table>
  </div>
</template>

<script setup>
import { reactive, computed } from 'vue';
import { useStore } from 'vuex';
import { tableOptions, paginationFor } from '../../../../helpers/tableOptions';
import { rewardLightboxPayload } from '@/helpers/rewardGallery';

const props = defineProps({
  rows: Array
})
const emit = defineEmits(['choose-reward-data']);

const store = useStore();

const imgRoot = computed(() => process.env.VUE_APP_IMG_ROOT);
const formatFn = (value) => {
  return store.getters.formatTableNumber(value);
};

const openRewardPhoto = (row) => {
  const payload = rewardLightboxPayload(
    imgRoot.value,
    row?.Reward || 'Výhra',
    row?.Image,
    row?.RewardImgs
  );
  if (!payload.src) return;
  store.dispatch('openLightbox', payload);
};

const columns = reactive([
  { 
    label: '',
    field: 'Image',
    thClass: 'text-uppercase text-dark text-xxs font-weight-bolder',
    tdClass: 'p-3',
  },
  { 
    label: 'Výhra',
    field: 'Reward',
    thClass: 'text-uppercase text-dark text-xxs font-weight-bolder',
    tdClass: 'text-sm font-weight-bold align-middle',
  },
  { 
    label: 'Hra',
    field: 'GameName',
    thClass: 'text-uppercase text-dark text-xxs font-weight-bolder',
    tdClass: 'text-sm font-weight-bold align-middle',
  },
  { 
    label: 'Kredit',
    field: 'Credit',
    thClass: 'text-uppercase text-dark text-xxs font-weight-bolder text-end',
    tdClass: 'text-sm font-weight-bold text-end align-middle',
    formatFn: formatFn
  },
  { 
    label: '',
    field: 'Actions',
    thClass: 'text-uppercase text-dark text-xxs font-weight-bolder text-end',
    tdClass: 'align-middle',
  }
]);

</script>